var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_fail_active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM12 10.908L9.10371 8.01172L12 5.11542L10.9041 4.01953L8.00781 6.91583L5.11152 4.01953L4.01562 5.11542L6.91192 8.01172L4.01564 10.908L5.11153 12.0039L8.00781 9.10761L10.9041 12.0039L12 10.908Z",
    fill: "#FFB400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAction);
export default __webpack_public_path__ + "static/media/icon-no-action.3555abd4e88a7e227d4390a3e583b648.svg";
export { ForwardRef as ReactComponent };